import Button from "../buttons/button";
import TransParentButton from "../TransparentButton.js/TransParentButton";


const StatusPopup = ({ isOpen, onClose, onConfirm, heading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm">
      <div className="bg-white p-6 rounded-[19px] shadow-lg text-center lg:w-[400px] w-11/12 mx-auto">
        <div className="flex items-center justify-center mb-4">
          <img src="/warning.png" alt="" className="w-20 h-20" />
        </div>
        <p className="text-[17px] font-[600] text-black mb-4">{heading}</p>
        <div className="flex justify-center gap-4">
          <TransParentButton
            onClick={onClose}>
            Cancel
          </TransParentButton>
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};
export default StatusPopup